function epicFollowBrand () {
  Shopify.theme.jsFollowBrand = {
    init: function init() {
      const followBrandBlocks = document.querySelectorAll('.js-follow-brand-block');
      followBrandBlocks.forEach(followBrandBlock => {
        this.followBrand(followBrandBlock);
      });
    },
    followBrand: function followBrand(followBrandBlock) {
      if (!followBrandBlock) return false;
      const followBrandButton = followBrandBlock.querySelector('.js-follow-brand-button');
      const followingBrandButton = followBrandBlock.querySelector('.js-following-brand-button');
      const followingBrandTooltip = followBrandBlock.querySelector('.js-brand-manage-tooltip');
      if (!followBrandButton || !followingBrandButton) return false;
      const brandId = followBrandButton.getAttribute('data-brand-id');
      const customerId = followBrandButton.getAttribute('data-customer-id');
      if (!brandId || !customerId) return false;
      let url;

      if (Orchestra && Orchestra.epic_favorite_brands_update) {
        url = Orchestra.epic_favorite_brands_update;
      } else {
        return false;
      }
      followBrandButton.addEventListener('click', e => {
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            brand_id: brandId,
            customer_id: customerId,
            action: 'add'
          })
        }).then(response => response.json()).then(json => {
          if (json.success != true) return false;
          followBrandButton.classList.add('hidden');
          followingBrandButton.classList.remove('hidden');
          if (followingBrandTooltip) followingBrandTooltip.classList.remove('hidden');
        }).catch(error => console.error(error));
      });
    }
  };
  Shopify.theme.jsFollowBrand.init();
}

export { epicFollowBrand as default };
